/// <reference lib="es2022.intl" />

const graphemeSegmenter = new Intl.Segmenter(undefined, {
  granularity: 'grapheme',
})

/**
 * 文字列を書記素(grapheme)単位で maxLength まで切り詰めます。
 * String.slice はサロゲートペアや絵文字などの複数コードポイントから成る
 * 書記素を分割してしまい表示が壊れるため、Intl.Segmenter で安全に分割します。
 *
 * @param str - 切り詰め対象の文字列。
 * @param maxLength - 残す書記素の最大数。
 * @returns maxLength 以下ならそのまま、超える場合は切り詰めて末尾に '...' を付けた文字列。
 */
export function truncate(str: string, maxLength: number): string {
  const segments = Array.from(graphemeSegmenter.segment(str), (s) => s.segment)
  if (segments.length <= maxLength) {
    return str
  }

  return `${segments.slice(0, maxLength).join('')}...`
}
